import React from "react";
import { useFormContext } from "react-hook-form";
import { Info } from "react-feather";
import Input from "Components/UI/Input";
const dateFormat = "YYYY-MM-DD";
import dayjs from "dayjs";
import { useResidentialsQuery } from "AppQuries/master/ResidentialType/get-all-residential-type";
import { useContributesQuery } from "AppQuries/master/CpfType/get-all-contributes";
import { useFormattedResidentialTypeOption } from "core/Operations/formattedOption/useFormattedMasterOptions";

const statusOptions = [
  { id: 1, label: "Yes", value: 1 },
  { id: 0, label: "No", value: 0 },
];

const contributeSdlOptions = [
  { id: 1, label: "Yes", value: "1" },
  { id: 0, label: "No", value: "0" },
];

const prcpfTypeOptions = [
  { id: "F", label: "Full", value: "F" },
  { id: "G", label: "Graduate", value: "G" },
];

const activeStatus = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];
const CPFDetails = () => {
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    trigger,
    clearErrors,
    getValues,
  } = useFormContext();

  const { data: residentials } = useResidentialsQuery(
    {
      companyCode: watch("companyCode"),
    },
    {
      enabled: !!watch("companyCode"),
    }
  );

  const { data: contributesList } = useContributesQuery();

  const contributeOptions = Array.isArray(contributesList?.data)
    ? [
        { id: "0", label: "None", value: 0 },
        ...(
          contributesList?.data?.filter((o) => o.isActive === true) || []
        ).map((o) => ({
          id: o.contributionCode,
          label: o.contributionName,
          value: o.contributionCode,
        })),
      ]
    : [{ id: "0", label: "None", value: 0 }];

  const residentialOptions = useFormattedResidentialTypeOption(
    watch("companyCode")
  );

  // Array.isArray(residentials?.data)
  // ? residentials?.data
  //     .filter((r) => r.isActive === true)
  //     .map((r) => ({
  //       id: r.shortCode,
  //       label: r.description,
  //       value: r.shortCode,
  //     }))
  // : [];

  return (
    <>
      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>CPF Details</span>
        </h5>
      </div>

      <div className="row">
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="residentialType"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.residentialType ? "is-invalid" : ""
            }`}
            label=" CPF Contribution Type"
            labelClassName="form-label"
            optionData={residentialOptions}
            required={watch("employeeType") === "3" ? false : true}
            requiredMessage="CPF Contribution is required"
            onChange={(selectedOption) => {
              setValue(
                "residentialType",
                selectedOption ? selectedOption : null
              );
              trigger("residentialType");
            }}
            defaultValue={watch("residentialType")}
          />
        </div>

        {watch("employeeType") !== "3" && (
          <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
            <Input
              name="prcpfType"
              type="commonSelect"
              placeholder=""
              className={`form-control ${
                errors.prcpfType ? " is-invalid" : ""
              }`}
              label="PR CPF Type"
              labelClassName="form-label"
              optionData={prcpfTypeOptions}
              required={
                watch("employeeType") === "3" || watch("employeeType") === "2"
                  ? false
                  : true
              }
              requiredMessage="PR CPF Type is required"
              onChange={(selectedOption) => {
                setValue("prcpfType", selectedOption ? selectedOption : null);
                trigger("prcpfType");
              }}
              defaultValue={watch("prcpfType")}
            />
          </div>
        )}

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="contributionCode"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.contributionCode ? " is-invalid" : ""
            }`}
            label="Contribute CPF"
            labelClassName="form-label"
            optionData={contributeOptions}
            required={watch("employeeType") === "3" ? false : true}
            requiredMessage="Contribute CPF is required"
            onChange={(selectedOption) => {
              setValue(
                "contributionCode",
                selectedOption ? selectedOption : null
              );
              trigger("contributionCode");
            }}
            defaultValue={watch("contributionCode")}
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="contributesSDL"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.contributesSDL ? " is-invalid" : ""
            }`}
            label="Contribute SDL"
            labelClassName="form-label"
            optionData={contributeSdlOptions}
            required={watch("employeeType") === "3" ? false : true}
            requiredMessage="Contribute SDL is required"
            onChange={(selectedOption) => {
              setValue(
                "contributesSDL",
                selectedOption ? selectedOption : null
              );
              trigger("contributesSDL");
            }}
            defaultValue={watch("contributesSDL")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="sdlBreakdown"
            type="text"
            placeholder=""
            className={`form-control ${
              errors.sdlBreakdown ? "is-invalid" : ""
            }`}
            label="Sdl Breakdown"
            labelClassName="form-label"
            required={false}
            requiredMessage="Sdl Breakdown is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="prDate"
            type="date"
            placeholder=""
            className={`form-control ${errors.prDate ? "is-invalid" : ""}`}
            label="PR Date"
            labelClassName="form-label"
            required={false}
            requiredMessage="PR Date is required"
            defaultValue={dayjs(watch("prDate"), dateFormat) || ""}
            dateFormat="DD-MM-YYYY"
          />
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].employeeCPFAccountNumber"
            type="text"
            placeholder="Employee CPF Account No"
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.employeeCPFAccountNumber
                ? "is-invalid"
                : ""
            }`}
            label="Employee CPF Account No"
            labelClassName="form-label"
            required={true}
            requiredMessage="Employee CPF Account No is required"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].additionalCPFAccount"
            type="text"
            placeholder="Additional CPF Account No"
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.additionalCPFAccount
                ? "is-invalid"
                : ""
            }`}
            label="Additional CPF Account No"
            labelClassName="form-label"
            required={true}
            requiredMessage="Additional CPF Account No is required"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].employerCPFAccount"
            type="text"
            placeholder="Employer CPF Account No"
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.employerCPFAccount
                ? "is-invalid"
                : ""
            }`}
            label="Employer CPF Account No"
            labelClassName="form-label"
            required={true}
            requiredMessage="Employer CPF Account No is required"
          />
        </div>
        {getValues("cpfAccountDetails[0].employeeAmount") > 0 && (
          <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
            <Input
              name="cpfAccountDetails[0].employeeAmount"
              type="text"
              placeholder="Employee Amount"
              className={`form-control ${
                errors?.cpfAccountDetails?.[0]?.employeeAmount
                  ? "is-invalid"
                  : ""
              }`}
              label="Employee Amount"
              labelClassName="form-label"
              required={true}
              requiredMessage="Employee Amount is required"
            />
          </div>
        )}
        {getValues("cpfAccountDetails[0].employerAmount") > 0 && (
          <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
            <Input
              name="cpfAccountDetails[0].employerAmount"
              type="text"
              placeholder="Employer Amount"
              className={`form-control ${
                errors?.cpfAccountDetails?.[0]?.employerAmount
                  ? "is-invalid"
                  : ""
              }`}
              label="Employer Amount"
              labelClassName="form-label"
              required={true}
              requiredMessage="Employer Amount is required"
            />
          </div>
        )}
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].voluntaryCPFContribution"
            type="text"
            placeholder="Voluntary CPF Contribution"
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.voluntaryCPFContribution
                ? "is-invalid"
                : ""
            }`}
            label="Voluntary CPF Contribution"
            labelClassName="form-label"
            required={true}
            requiredMessage="Voluntary CPF Contribution is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].autoDetectCPF"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.autoDetectCPF ? " is-invalid" : ""
            }`}
            label="Auto Deduct CPF"
            labelClassName="form-label"
            optionData={activeStatus}
            required={true}
            requiredMessage="Auto Deduct CPF is required"
            onChange={(selectedOption) => {
              setValue("cpfAccountDetails[0].autoDetectCPF", selectedOption);
              trigger("cpfAccountDetails[0].autoDetectCPF");
            }}
            defaultValue={watch("cpfAccountDetails[0].autoDetectCPF")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].includeIR8ASubmission"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.includeIR8ASubmission ? " is-invalid" : ""
            }`}
            label="Include IR8A Submission"
            labelClassName="form-label"
            optionData={activeStatus}
            required={true}
            requiredMessage="Include IR8A Submission is required"
            onChange={(selectedOption) => {
              setValue(
                "cpfAccountDetails[0].includeIR8ASubmission",
                selectedOption
              );
              trigger("cpfAccountDetails[0].includeIR8ASubmission");
            }}
            defaultValue={watch("cpfAccountDetails[0].includeIR8ASubmission")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].sdfRequired"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.sdfRequired ? " is-invalid" : ""
            }`}
            label="SDF Required?"
            labelClassName="form-label"
            optionData={activeStatus}
            required={true}
            requiredMessage="Have SDF is required"
            onChange={(selectedOption) => {
              setValue("cpfAccountDetails[0].sdfRequired", selectedOption);
              trigger("cpfAccountDetails[0].sdfRequired");
            }}
            defaultValue={watch("sdfRequired")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].cpfStatus"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.cpfStatus ? " is-invalid" : ""
            }`}
            label="CPF Status"
            labelClassName="form-label"
            optionData={activeStatus}
            required={true}
            requiredMessage="CPF Status is required"
            onChange={(selectedOption) => {
              setValue("cpfAccountDetails[0].cpfStatus", selectedOption);
              trigger("cpfAccountDetails[0].cpfStatus");
            }}
            defaultValue={watch("cpfAccountDetails[0].cpfStatus")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="cpfAccountDetails[0].isActive"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors?.cpfAccountDetails?.[0]?.isActive ? " is-invalid" : ""
            }`}
            label="Active Status"
            labelClassName="form-label"
            optionData={activeStatus}
            required={true}
            requiredMessage="Active Status is required"
            onChange={(selectedOption) => {
              setValue("cpfAccountDetails[0].isActive", selectedOption);
              trigger("cpfAccountDetails[0].isActive");
            }}
            defaultValue={watch("cpfAccountDetails[0].isActive")}
          />
        </div>
      </div>
    </>
  );
};

export default CPFDetails;
